import { Theme } from "@mui/material";

export const getIconColor = (label: string, theme: Theme) => {
    if (label.includes("contractors")) return theme.palette.primary.main;
    if (label.includes("projects")) return theme.palette.success.main;
    if (label.includes("activities")) return theme.palette.info.main;
    if (label.includes("delivery")) return theme.palette.warning.main;
    return theme.palette.primary.main;
};